import React, { useContext, createContext, useReducer } from 'react'

export const SHOW_CONFIRM = 'SHOW_CONFIRM'
export const HIDE_CONFIRM = 'HIDE_CONFIRM'

const initialState = {
  show: false,
  title: '',
  text: '',
  canCancel: true
}

const confirmContext = createContext()

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_CONFIRM:
      return {
        show: true,
        title: action.payload.title,
        text: action.payload.text,
        canCancel: action.payload.canCancel,
      }
    case HIDE_CONFIRM: return initialState;
    default:
      return initialState
  }
}

export function ProvideDialog({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <confirmContext.Provider value={[ state, dispatch ]}>
      {children}
    </confirmContext.Provider>
  )
}

let resolveCallback
export default function useConfirm() {
  const [confirmState, dispatch] = useContext(confirmContext)
  const onConfirm = () => {
    closeConfirm()
    resolveCallback(true)
  }
  const onCancel = () => {
    closeConfirm()
    resolveCallback(false)
  }
  const confirm = (title, text, canCancel=true) => {
    dispatch({ type: SHOW_CONFIRM, payload: { title, text, canCancel } })
    return new Promise((res, rej) => {
      resolveCallback = res
    })
  }
  const closeConfirm = () => {
    dispatch({ type: HIDE_CONFIRM })
  }
  return { confirm, onConfirm, onCancel, confirmState }
}